export { default as Main } from './Main.jsx';


// WEBPACK FOOTER //
// ./src/components/Main/index.jsx